export const allToPromise = <T, R>(collection: Array<T>, fn: (thing: T) => R) => Promise.all(collection.map(fn));
